var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.5C25.3675 21.5 28.5 18.3675 28.5 14.5C28.5 10.6325 25.3675 7.5 21.5 7.5C17.6325 7.5 14.5 10.6325 14.5 14.5C14.5 18.3675 17.6325 21.5 21.5 21.5ZM21.5 25C16.8275 25 7.5 27.345 7.5 32V35.5H35.5V32C35.5 27.345 26.1725 25 21.5 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFilled);
export default __webpack_public_path__ + "static/media/PersonFilled.89ca0b69.svg";
export { ForwardRef as ReactComponent };